//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapActions, mapState} from 'vuex';
import http from '@/fetch/http';
import util from '@/utils'
import * as types from '../../vuex/types'
import Personal from '@/page/Personal.vue'
import store from '@/vuex/store'
import ExamBreadcrumb from '@/components/common/ExamBreadcrumb.vue'
import ExerBasket from '@/components/common/ExerBasket.vue'

export default {
  name: 'headerBar',
  inject: ["reload"],
  data() {
    return {
      navlists: [
//          {text: '班级管理', to: 'classroom', icon: 'icon-siyecao'},
        {text: '个人信息', to: 'personal', icon: 'icon-xuesheng3'},
      ],
      showMain: false,
      headerName: "",
      examType: "",
      showShare: false,
      uurl: ''
    };
  },
  props: [
    'leave'
  ],
  computed: {
    ...mapState({
      serverIp: state => state.status.serverIp,
      exerciseCount: state => state.status.exerciseCount,
      headerPic2: state => state.headerPic2,
      headerthree: state => state.status.headerthree,
      headerfour: state => state.status.headerfour,
      userInfo: state => state.user.userInfo,
      dropwindow: state => state.status.showDropWindow,
      clickExerBasketFlag: state => state.status.clickExerBasketFlag,
      headerPic: state => state.headerPic2,
    })
  },
  components: {
    Personal,
    ExamBreadcrumb,
    ExerBasket
  },
  watch: {
    activeTap() {
      this.bankId = '';
    }
  },
  methods: {
    ...mapActions({
      setServerIp: 'setServerIp',
      setExerciseCount: 'setExerciseCount',
      setWebsocketUrl: 'setWebsocketUrl',
      setHeaderThree: 'setHeaderThree',
      setHeaderFour: 'setHeaderFour',
      showdropwindow: 'showDropWindow',
      setSignOut: 'setSignOut',
      //授课返回第一页
      setTeachIndex: 'setTeachIndex',
      setTableScreenWidth: 'setTableScreenWidth',
      setClickExerBasketFlag: 'setClickExerBasketFlag',
      setNoviceFlag: 'setNoviceFlag',
      setNoviceNewFlag: 'setNoviceNewFlag'
    }),
    showNovice() {
      this.setNoviceFlag(true);
      this.setNoviceNewFlag(true);
      this.$router.replace('/moduleOption');
      this.reload();
    },
    changeClickExerBasketFlag(flag) {
      this.setClickExerBasketFlag(flag);
    },
    clickExerBasket() {
      this.setClickExerBasketFlag(!this.clickExerBasketFlag);
      this.$refs.exerBasketRef.clickExerBasket();
    },
    clickdropwindow() {
      if (this.dropwindow) {
        this.showdropwindow(1);
      } else {
        this.showdropwindow(1);
      }
    },
    showThumbPath(img, subfix) {
      return util.showThumbPath(img, subfix);
    },
    goHome() {
      this.$router.replace('/moduleOption');
      this.reload();
      this.setHeaderThree('');
      this.setHeaderFour(0);
      this.headerName = "首页"
    },
    goHomePage() {
      this.$router.replace('/homePage');
      this.reload();
      this.setHeaderThree('');
      this.setHeaderFour(0);
      this.headerName = "首页"
    },
    goStatisticalAnalysis() {
      this.$router.replace('/homePage/statisticalAnalysis');
      this.reload();
      this.setHeaderThree('');
      this.setHeaderFour(0);
      this.headerName = "统计分析"
    },
    goUseAnalysis() {
      this.$router.replace('/homePage/useAnalysis');
      this.setHeaderThree('');
      this.setHeaderFour(0);
      this.headerName = "使用分析"
    },
    goStudent() {
      this.$router.replace('/homePage/students');
      this.setHeaderThree('');
      this.setHeaderFour(0);
      this.headerName = "学生管理"
    },
    goScoreManagement() {
      if (this.userInfo.role.roleCode == 'appadmin') {
        this.$router.replace('/homePage/scoreManagement');
        this.reload();
        this.setHeaderThree('');
        this.setHeaderFour(0);
        this.headerName = "成绩管理"
      } else {
        this.$router.replace('/homePage/scoreDeanManagement');
        this.reload();
        this.setHeaderThree('');
        this.setHeaderFour(0);
        this.headerName = "成绩管理"
      }

    },
    skillMatch() {
      window.location.href = types.SKILL_MATCH_SERVER_HOST + "/skill/teacher/skillmatch";
    },
    examPlatform() {
      this.$router.push('/home/homelist');
    },
    goTopiclibrary() {
      this.$router.push('/home/schoolBank');
      this.reload();
      // this.$router.push('/home/topiclibrary');
      this.setHeaderThree('');
      this.headerName = "题库"
    },
    shareTopiclibrary() {
      this.$router.push('/home/ShareTopiclibrary');
      this.setHeaderThree('');
      this.headerName = "题库"
    },
    goPaperlibrary() {
      this.$router.push('/home/schoolPaper');
      this.reload();
      // this.$router.push('/home/paperlibrary');
      this.setHeaderThree('');
      this.headerName = "题库"
    },
    practice() {
      this.$router.push('/home/practice');
      this.setHeaderThree('');
      this.headerName = "题库"
    },
    gotoResources() {
      this.$router.push('/homePage/resource');
      this.reload();
      this.setHeaderThree('');
      this.headerName = "资源"
    },
    reportlibrary(examType) {
      if (examType == '0') {
        this.examType = 0
        this.$router.push('/home/reportlibrary/' + examType);
      } else {
        this.examType = 1
        this.$router.push('/home/reportlibrary/' + examType);
      }
      this.reload();
      this.setHeaderThree('');
      this.headerName = "成绩"
    },
    teachCourse() {
      this.$router.push('/teachCourse');
      this.setHeaderThree('');
      this.headerName = "管理"
    },
    teachClass() {
      this.$router.push('/teachClass');
      this.setHeaderThree('');
      this.headerName = "管理"
    },
    classMasterExamReport() {
      this.$router.push('/home/classmasterreportlibrary');
      this.setHeaderThree('');
      this.headerName = "管理"
    },
    educationalAdministratorExamReport() {
      this.$router.push('/home/educationalAdministratorreportlibrary');
      this.setHeaderThree('');
      this.headerName = "管理"
    },
    goExamination() {

    },
    goReturn() {
      this.$router.replace(this.$route.meta.path);
      this.setHeaderThree('');
      this.setHeaderFour(0);
    },
    goCourse() {
      this.$router.replace('/home/course');
      this.setHeaderThree('');
      this.setHeaderFour(0);
    },
    goCourseware() {
      this.$router.replace('/home/courseware');
      this.setHeaderThree('');
      this.setHeaderFour(0);
    },
    goClassroom() {
      this.$router.replace('/home/classroom');
      this.setHeaderThree('');
      this.setHeaderFour(0);
    },
    _goto(to) {
      this.showShare = true;
      this.showdropwindow(0);
//        this.$router.push({path: '/home/' + to})
//        this.setHeaderThree('');
//        this.setHeaderFour(0);
    },
    goGroupPaper() {
      this.$router.push('/homePage/groupPaper');
      this.setHeaderThree('');
      this.headerName = "组卷"
    },
    //个人信息
    jumpPersonalManagement(to) {
      localStorage.type = 'header'; //来源flag记录
      this.$router.push('/homepage/personalManagement');
    },
    /**
     * 关闭页面
     * @param flag
     */
    closePage(flag) {
      this.showShare = flag
    },
    showThumbPath(path) {
      return util.showThumbPath(path, 'header');
    },
    uploadImage(event) {
      var self = this;
      let formData = new FormData();
      formData.append("file", event.file);
      formData.append("chunk", 0);
      formData.append("chunks", 1);
      formData.append("fileName", event.file.name);
      formData.append("schoolId", this.userInfo.schoolId);
      formData.append("userId", this.userInfo.id);
      http.uploadFileOfResource(formData)
        .then(res => {
          if (res.status = "success") {
            let params = {
              userId: this.userInfo.id,
              path: res.data.path
            }
            http.saveHeadPortrait(params).then(result => {
              if (result.msgCode == 1) {
                self.imageSrc = res.data.path;
                self.userInfo.photo = res.data.path;
                //self.setUserInfo(self.userInfo);
              }
            })
          }
        })
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    _logout() {
      let u = navigator.userAgent, app = navigator.appVersion;
      let browserInfo = {
        mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
        android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, //android终端
        iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
        iPad: u.indexOf('iPad') > -1 //是否iPad
      };

      var isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

      this.showdropwindow(0);
      store.state.prePath = "";
      http.Logout(this.userInfo).then(res => {
        this.setHeaderThree('');
        this.setHeaderFour(0);
        this.setSignOut();
        if (browserInfo.mobile || browserInfo.iPad || browserInfo.iPhone|| browserInfo.ios|| browserInfo.android|| browserInfo.iPad) {
          this.$router.replace("/mobileLogin");
        } else {
          this.$router.replace("/login");
        }
        // 登录页面刷新两次，没有必要
        // window.location.reload();
      });
    },
    initSysParam() {
      var $this = this;
      $this.setClickExerBasketFlag(false);
      $this.setExerciseCount();
      http.GetServerIp()
        .then(res => {
          if (res.msgCode == types.STATUS_OK) {
            $this.setServerIp(res.data.serverIp);
            $this.setWebsocketUrl(res.data.webSocketPath + "/websocket");
          } else {
          }
        }).catch(error => {
      })

      http.getTableScreenWidth()
        .then(res => {
          if (res.msgCode == types.STATUS_OK) {
            $this.setTableScreenWidth(res.data);
          }
        })
    },
  },
  created() {
    this.initSysParam();
  }
}



// WEBPACK FOOTER //
// ./src/components/common/Headers.vue